import NsContent from 'components/common/ns-content/NsContent';
import NsStandout from '@britishgasenergy/react-nucleus/dist/nuc-components/NsStandout';

import { NsTitle } from 'components/common/ns-title/NsTitle';
import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { NsAlert } from 'components/common/ns-alert/NsAlert';
import { useNavigation } from 'hooks/useNavigation';

export const testId = 'classicSupplyTestId';

export const ClassicSupply = () => {
  const { next, eventTypes } = useNavigation();

  const handleGoNext = () => {
    next({ eventType: eventTypes.NEXT });
  };

  return (
    <NsPanel testId={testId}>
      <NsBackCta />
      <NsContent>
        <NsTitle title="Good news - we’re updating our system" />
        <NsStandout decoration="cyan">
          <h5>You’re new address isn’t on the new system... yet!</h5>
          <p>
            We’re really excited about our new system and the updates we’ve made
            so far. We’re on a mission to make managing energy easier for our
            customers.
          </p>
          <p>
            Your new address hasn’t been moved over just yet, so will need to
            set you up on the current system until it’s ready to be moved over.
          </p>
        </NsStandout>
        <h4>When will my account be moved?</h4>
        <p>
          We’ll write to you soon to let you know when your account has been
          moved. <b>There’s nothing you’ll need to do</b>, we’ll take care of
          everything. Your energy supply, tariff and payment details will all be
          the same based on your move in details.
        </p>
        <NsAlert state="info" heading="Fixed energy deals now available">
          <p>
            And, if we bring out an even better fixed tariff in the months to
            come - you can swap for free.
          </p>
        </NsAlert>
        <NsPrimaryCta onClick={handleGoNext}>
          Let’s get you moved in
        </NsPrimaryCta>
      </NsContent>
    </NsPanel>
  );
};

export default ClassicSupply;
